export default __webpack_public_path__ + "static/media/05-2.c568d319.jpg";